import { render } from "./NewsArea.vue?vue&type=template&id=70774f4e"
import script from "./NewsArea.vue?vue&type=script&lang=js"
export * from "./NewsArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__